<template>
  <div>
    <!-- Header: Personal Info -->
    <!-- <div class="d-flex">
      <h4 class="mb-0">Email Addresses</h4>
    </div> -->

    <!-- Form: Personal Info Form -->
    <b-form class="">
      <!-- Form: Personal Info Form -->
      <div class="simple-spinner" v-if="!isLoaded">
        <span></span>
      </div>

      <b-form ref="form" @submit.prevent="repeateAgain" v-else>
        <h5 v-if="addresses.length === 0" class="text-center">No email addresses listed</h5>

        <!-- Row Loop -->
        <b-row v-for="(item, index) in addresses" :id="item.id" :key="item.id" ref="row">
          <!-- Item Name -->
          <b-col lg="3" md="3" sm="12">
            <b-form-group label="Email Label" :label-for="`address-label-${index}`">
              <b-form-input
                :id="`address-label-${index}`"
                type="text"
                placeholder="Email Label"
                v-model="item.label"
                :disabled="item.label.startsWith('MyIP:')"
                @change="fixAddItem(index)"
              />
            </b-form-group>
          </b-col>

          <!-- Email Address -->
          <b-col lg="5" md="5" sm="12">
            <b-form-group label="Email" :label-for="`address-email-${index}`">
              <b-form-input
                :id="`address-email-${index}`"
                type="email"
                placeholder="student123@domain.com"
                v-model="item.email"
                :disabled="item.label === 'MyIP: Forwarded Email'"
              />
            </b-form-group>
          </b-col>

          <!-- Type -->
          <b-col lg="2" md="2" sm="12">
            <b-form-group label="Type" :label-for="`address-type-${index}`">
              <v-select
                :id="`address-type-${index}`"
                :value="item.type"
                :options="[
                  { label: 'Personal', value: 'personal' },
                  { label: 'School', value: 'school' },
                  { label: 'Work', value: 'work' },
                ]"
                class="w-100"
                :clearable="false"
                :reduce="(val) => val.value"
                :disabled="item.label.startsWith('MyIP:')"
                @input="(val) => (item.type = val)"
              />
            </b-form-group>
          </b-col>

          <!-- Remove Button -->
          <b-col lg="2" md="2" class="mb-50">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mt-0 mt-md-2"
              @click="removeItem(index)"
              v-if="!item.label.startsWith('MyIP:')"
            >
              <feather-icon icon="XIcon" class="mr-25" />
              <span>Delete</span>
            </b-button>
          </b-col>
          <b-col cols="12">
            <hr />
          </b-col>
        </b-row>
      </b-form>

      <b-row class="mt-2 w-100">
        <b-col cols="12" lg="12">
          <b-button variant="primary" class="float-right" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="doSaveChanges">
            Save Changes
          </b-button>
          <b-button
            variant="outline-secondary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1 float-right"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="$router.back()"
          >
            <feather-icon icon="ArrowLeftIcon" />
            Return
          </b-button>

          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="repeateAgain">
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>Add New</span>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadioGroup, BFormCheckboxGroup, BButton, BFormCheckbox } from 'bootstrap-vue';
import flatPickr from 'vue-flatpickr-component';
import { onMounted, onUnmounted, ref } from '@vue/composition-api';
import vSelect from 'vue-select';
import store from '@/store';
import rosterStoreModule from '@/store/roster/rosterStoreModule';
import router from '@/router';
import ToastificationContent from '@core/components/toastification/ToastificationContent';
import useStudents from '../../useStudents';
import { heightTransition } from '@core/mixins/ui/transition';
import Ripple from 'vue-ripple-directive';
import studentStoreModule from '@/store/student/studentStoreModule';

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    flatPickr,
    BFormInput,
    vSelect,
    BFormRadioGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    BButton,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    studentData: {
      type: Object,
      required: true,
    },
  },
  watch: {
    studentData: function () {},
  },
  data: () => {
    return {
      submit: { sync: false },

      addresses: [],
      nextTodoId: 1,
      isLoaded: false,
    };
  },
  methods: {
    fixAddItem(index) {
      if (this.addresses[index].label.startsWith('MyIP:')) {
        this.addresses.splice(index, 1);
      }
    },
    doSaveChanges() {
      const pwd = this.studentData;
      const id = pwd.id;

      this.addresses = this.addresses.filter((add) => {
        if (!add.email) return false;
        return true;
      });

      store
        .dispatch('studentStoreModule/updateStudentProfile', {
          id,
          profileData: { emailAddresses: this.addresses },
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Student Edited!',
              icon: 'EditIcon',
              variant: 'success',
            },
          });

          this.loadProfile();
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Failed to edit student',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: error.response ? error.response.data.message : error.message,
            },
          });
        });
    },
    repeateAgain() {
      this.addresses.push({ email: '', label: '', type: 'Personal' });
    },
    removeItem(index) {
      this.addresses.splice(index, 1);
    },
    loadProfile() {
      store.dispatch('studentStoreModule/fetchStudentProfile', { id: this.studentDataInfo.id }).then((response) => {
        this.addresses = response.data.emailAddresses;
        this.isLoaded = true;
      });
    },
  },
  mounted() {
    this.loadProfile();
  },
  setup(props) {
    const studentDataInfo = ref(props.studentData);

    const { statusOptions } = useStudents();

    return {
      studentDataInfo,
      statusOptions,
    };
  },
};
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
